angular.
module("dx.webapp.question").
factory("DxQuestion", function questionService(
	$window,

	Alternative,
	DX_QUESTION_GRADING_TYPE,
	DX_QUESTION_TYPE,

	DX_CAP_SETTINGS,
	DX_GRADING_TYPES,
	dxLocalize
) {
	"use strict";

	var textualQuestionTemplate = {
		capSetting: DX_CAP_SETTINGS.NONE,
		capValue: null,

		isCapSettingValid: function isCapSettingValid() {
			return this.capSetting === DX_CAP_SETTINGS.NONE || this.capValue >= 1;
		},
	};

	var choiceQuestionTemplate = {
		alternatives: [],
		gradingType: DX_QUESTION_GRADING_TYPE.ALL_OR_NOTHING,
		isAlternativeChoiceLimitEnabled: false,
		alternativeChoiceLimit: 0,
		correctAlternativeCount: 0,

		addAlternative: function addAlternative(data) {
			var alternative = new Alternative(data);
			this.alternatives = this.alternatives.slice();
			this.alternatives.push(alternative);
			this.setDirty(true);
		},

		removeAlternative: function removeAlternative(index) {
			this.alternatives = this.alternatives.filter(function forEachAlternative(val, i) {
				return i !== index;
			});
			this.setDirty(true);
		},

		setCorrectAlternative: function setCorrectAlternative(alternative, isCorrect) {
			if (this.type === DX_QUESTION_TYPE.SINGLE_CHOICE && isCorrect) {
				for (var i = 0; i < this.alternatives.length; i++) {
					this.alternatives[i].right = false;
				}
				this.correctAlternativeCount = 1;
			}

			alternative.right = isCorrect;
			if (this.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE) {
				this.countCorrectAlternatives();
			}
			this.setDirty(true);
		},

		hasCorrectAlternative: function hasCorrectAlternative() {
			return this.correctAlternativeCount > 0;
		},

		countCorrectAlternatives: function countCorrectAlternatives() {
			var correctCount = 0;

			for (var i = 0; i < this.alternatives.length; i++) {
				if (this.alternatives[i].right) {
					correctCount++;
				}
			}

			this.correctAlternativeCount = correctCount;
		},
	};

	var wordGapQuestionTemplate = {
		gradingType: DX_QUESTION_GRADING_TYPE.ALL_OR_NOTHING,
		blanks: [],
		matching: 0,
		caseSensitive: false,
		validation: {
			noWordGaps: false,
			emptyWordGaps: false,
		},

		hasWordGaps: function hasWordGaps() {
			return this.blanks.length > 0;
		},

		hasEmptyWordGaps: function getEmptyWordGaps() {
			for (var i = 0; i < this.blanks.length; i++) {
				var blank = this.blanks[i];
				var isEmpty = true;

				for (var j = 0; j < blank.validations.length; j++) {
					if (blank.validations[j].phrase) {
						isEmpty = false;
						break;
					}
				}

				if (isEmpty) {
					return true;
				}
			}

			return false;
		},

		parseBody: function parseBody() {
			var self = this;
			var blanks = [];

			$window.$(self.bodyHTML).find("[dx-wg-id]").each(function each(i, element) {
				blanks.push({
					guid: element.getAttribute("dx-wg-id"),
					validations: [
						{
							matchingType: self.matching,
							caseSensitive: self.caseSensitive,
							phrase: element.textContent.replace("\u200b", ""),
						},
					],
				});
			});

			self.blanks = blanks;
		},

		populateBody: function populateBody() {
			var jQBodyHtml = angular.element("<div></div>");
			jQBodyHtml.append(this.bodyHTML);

			if (this.blanks.length > 0 && this.blanks[0].validations.length > 0) {
				var firstValidation = this.blanks[0].validations[0];

				this.matching = firstValidation.matchingType;
				this.caseSensitive = firstValidation.caseSensitive;
			}

			for (var j = 0; j < this.blanks.length; j++) {
				var blank = this.blanks[j];
				var answer = blank.validations.length > 0 ? blank.validations[0].phrase : "";
				jQBodyHtml.find("[dx-wg-id='" + blank.guid + "']").text(answer);
			}

			this.bodyHTML = jQBodyHtml.html();
		},
	};

	return function Question(type, data) {
		if (!(this instanceof Question)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		// Base properties
		var dirty = false;

		angular.extend(this, {
			id: 0,
			type: type,
			title: "",
			about: "",
			bodyHTML: "",
			images: [],
			maxScore: null,
			notes: "",
			// answer: null
			grades: [],
			matrixAbilityMask: [],
			onlineResources: [],
			editorVersion: 0,
			validation: {
				bodyValid: true,
			},
		});

		switch (type) {
			case DX_QUESTION_TYPE.TEXT:
				angular.extend(this, angular.copy(textualQuestionTemplate));
				break;

			case DX_QUESTION_TYPE.SINGLE_CHOICE:
			case DX_QUESTION_TYPE.MULTIPLE_CHOICE:
				angular.extend(this, angular.copy(choiceQuestionTemplate));
				break;

			case DX_QUESTION_TYPE.WORD_GAP:
				angular.extend(this, angular.copy(wordGapQuestionTemplate));
				break;

			default:
				throw new Error("Unsupported question type", type);
		}

		if (data) {
			angular.extend(this, data);
		}

		if (this.populateBody) {
			this.populateBody();
		}

		// Convert to alternative objects.
		if (this.alternatives) {
			for (var i = 0; i < this.alternatives.length; i++) {
				this.alternatives[i] = new Alternative(this.alternatives[i]);
			}
			this.countCorrectAlternatives();
		}

		// Always set current version explicitly.
		this.editorVersion = 2;

		this.hasMatrixAbilitiesEnabled = function hasMatrixAbilitiesEnabled() {
			return this.matrixAbilityMask.length;
		};

		this.hasMatrixAbilityEnabled = function hasMatrixAbilityEnabled(ability) {
			return this.matrixAbilityMask.indexOf(ability.id) !== -1;
		};

		this.toggleMatrixAbility = function toggleMatrixAbility($event, ability) {
			if ($event.target.checked) {
				this.matrixAbilityMask.push(ability.id);
			} else {
				var abilityIndex = this.matrixAbilityMask.indexOf(ability.id);
				this.matrixAbilityMask.splice(abilityIndex, 1);
			}
		};

		this.removeMatrixAbilities = function removeMatrixAbilities() {
			this.matrixAbilityMask = [];
		};

		this.isDirty = function isDirty() {
			if (this.type === DX_QUESTION_TYPE.SINGLE_CHOICE || this.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE) {
				for (var j = 0; j < this.alternatives.length; j++) {
					if (this.alternatives[j].isDirty()) {
						return true;
					}
				}
			}

			return dirty;
		};

		this.setDirty = function setDirty(state) {
			if (this.type === DX_QUESTION_TYPE.SINGLE_CHOICE || this.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE) {
				for (var j = 0; j < this.alternatives.length; j++) {
					this.alternatives[j].setDirty(state);
				}
			}

			dirty = state;
		};

		this.isValid = function isValid(_outErrors, gradingType) {
			var errors = [];
			if (this.title.length === 0) {
				errors.push({id: "title-q-" + this.$$hashKey, msg: dxLocalize.get("AQuestionNeedsATitle")});
			}

			if (!this.bodyHTML) {
				errors.push({id: "about-q-" + this.$$hashKey, msg: dxLocalize.get("AQuestionNeedsText")});
			}

			// Type specific validation
			switch (this.type) {
				case DX_QUESTION_TYPE.SINGLE_CHOICE:
				case DX_QUESTION_TYPE.MULTIPLE_CHOICE:
					if (this.alternatives.length === 0) {
						errors.push({
							id: "alt-q-" + this.$$hashKey,
							msg: dxLocalize.get("AMOrSQuestionNeedsAlternatives"),
						});
					}

					for (var j = 0; j < this.alternatives.length; j++) {
						var alt = this.alternatives[j];
						if (!alt.isValid()) {
							errors.push({
								id: "alt-" + alt.$$hashKey + "-q-" + this.$$hashKey,
								msg: dxLocalize.get("AQuestionAlternativeNeedsATitle"),
							});
						}
					}

					if (!this.hasCorrectAlternative()) {
						errors.push({
							id: "alt-q-" + this.$$hashKey,
							msg: dxLocalize.get("AMOrSQuestionNeedsCorrectAlternative"),
						});
					}

					if (this.isAlternativeChoiceLimitEnabled && this.alternativeChoiceLimit === 0) {
						errors.push({
							id: "gradingoptions-q-alternativeChoiceLimit-" + this.$$hashKey,
							msg: dxLocalize.get("GradingOptions.LimitedAlternatives.Error"),
						});
					}
					break;

				case DX_QUESTION_TYPE.WORD_GAP:
					this.validation.noWordGaps = false;
					this.validation.emptyWordGaps = false;

					if (!this.bodyHTML) {
						break;
					}

					if (!this.hasWordGaps()) {
						errors.push({
							id: "about-q-" + this.$$hashKey,
							msg: dxLocalize.get("WordGap.Validation.NoBlanks"),
						});

						this.validation.noWordGaps = true;
					} else if (this.hasEmptyWordGaps()) {
						errors.push({
							id: "about-q-" + this.$$hashKey,
							msg: dxLocalize.get("WordGap.Validation.EmptyBlanks"),
						});

						this.validation.emptyWordGaps = true;
					}
					break;

				case DX_QUESTION_TYPE.TEXT:
					if (!this.isCapSettingValid()) {
						errors.push({id: "cap-q-" + this.$$hashKey, msg: dxLocalize.get("AQuestionHasAnInvalidCap")});
					}
					break;

				default:
					throw new Error("Unsupported question type in validation");
			}

			if (gradingType === DX_GRADING_TYPES.SCORE) {
				if (!this.maxScore && this.maxScore !== 0) {
					errors.push({id: "maxscore-q-" + this.$$hashKey, msg: dxLocalize.get("AQuestionNeedsAMaxScore")});
				}

				if (this.maxScore < 0) {
					errors.push({id: "maxscore-q-" + this.$$hashKey, msg: dxLocalize.get("CantBeLowerThanX", 0)});
				}
			}

			for (var k = 0; k < errors.length; k++) {
				_outErrors.push(errors[k]);
			}

			return errors.length === 0;
		};
	};
});
